import { formatCurrency } from './format-currency.js';
/**
 * Formats a minor-units amount as a human-readable hourly rate string.
 *
 * Example: formatRate(150000, 'ZAR') => 'R1,500.00 / hour'
 */
export function formatRate(minorUnits, currency) {
    return `${formatCurrency(minorUnits, currency)} / hour`;
}
